import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RouterModule, RouterOutlet } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { AdminAuthComponent } from '../../auth/admin-auth-component/admin-auth-component';
import { Tournament } from '../shared/tournament';
import { TournamentCategory } from '../shared/tournament-category';
import { OpenSquashService } from '../shared/services/open-squash-service';

@Component({
  selector: 'app-conc-juvenil-2024',
  imports: [RouterModule, RouterOutlet, CommonModule],
  templateUrl: './conc-juvenil-2024.html',
  styleUrl: './conc-juvenil-2024.scss'
})
export class ConcJuvenil2024 {
  private openSquashService = inject(OpenSquashService);
  private dialog = inject(MatDialog);

  tournament!: Tournament;
  categories: TournamentCategory[] = [];
  esAdmin$!: Observable<boolean>;
  tournamentSubscription!: Subscription;

  ngOnInit(): void {
    this.esAdmin$ = this.openSquashService.esAdmin$;
    this.openSquashService.setTournament('conc-juvenil-2025');
    this.tournamentSubscription = this.openSquashService.tournament$.subscribe(tournament => {
      this.tournament = tournament;
      this.categories = tournament.categories.sort((a, b) => a.categoryOrder - b.categoryOrder);
    });
  }

  authAdmin() {
    this.dialog.open(AdminAuthComponent).afterClosed().subscribe(result => {
      if (result) {
        this.openSquashService.setAsAdmin(true);
      }
    });
  }

  logout() {
    this.openSquashService.setAsAdmin(false);
  }

  ngOnDestroy(): void {
    this.tournamentSubscription.unsubscribe();
  }

}
